import React, { Component } from 'react'
import {Link} from 'react-router-dom'
import {
  Container,
  Grid,
  Header,
  Button,
  Divider,
  Segment,
  List,
  Image,
  Item,
  Icon,
  Card,
  Tab,
  Search,
  Progress,
  Table
} from 'semantic-ui-react'

const Airtable = require('airtable')
const base = new Airtable({apiKey: 'keyEr9XzifZuH1Scd'}).base('appOWsqX1TswxQjdZ')

const compositionCredits = [
  {
    name: 'Michael Tucker',
    IPINumber: 649447603,
    copyrightShare: '31.6666666%',
    writerShare: '',
    publisherShare: '',
    publishedBy: 'Kobalt Music Publishing, OWSLA Publishing, Pulse',
    PRO: 'ASCAP',
    'copyrightHolder': 'Michael Diamond Music, Kobalt Music Copyrights Sarl o/b/o OWSLA TRAX, These Are Songs of Pulse'
  },
  {
    name: 'Julia Michaels',
    IPINumber: 608882910,
    copyrightShare: '31.6666667%',
    writerShare: '',
    publisherShare: '',
    publishedBy: 'Warner Chappell',
    PRO: 'BMI',
    copyrightHolder: 'Warner-Tamerlane Publishing Corp. Thanks For The Songs Richard. All Rights On Behalf Of Itself And Thanks For The Songs Richard Administered By Warner Tamerlane Publishing Corp. BMI'
  },
  {
    name: 'Justin Traner',
    IPINumber: 403302912,
    copyrightShare: '31.6666667%',
    writerShare: '',
    publisherShare: '',
    publishedBy: 'Warner Chappell',
    PRO: 'BMI',
    copyrightHolder: 'Warner-Tamerlane Publishing Corp. Thanks For The Songs Richard. All Rights On Behalf Of Itself And Thanks For The Songs Richard Administered By Warner Tamerlane Publishing Corp. BMI'
  },
  {
    name: 'Justin Bieber',
    IPINumber: 649447603,
    copyrightShare: '5%',
    writerShare: '',
    publisherShare: '',
    publishedBy: 'UMPG',
    PRO: 'ASCAP',
    copyrightHolder: 'Bieber Time Publishing, Universal Music Corporation'
  }
]

export default class Home extends Component {
  constructor(props) {
      super(props)
      this.state = {
        song: null,
        distributor: null,
        composition: null
      }
  }

  componentDidMount () {
    var self = this
    var dist = null
    console.log('ID ', this.props.match)
    base('Catalog').find(this.props.match.params.id, function(err, record) {
      if (err) { console.error(err); return }
        base('Rights Holder Network').find(record.get('Distributor'), function(err, dist) {
          if (err) { console.error(err); return; }

          base('Compo')

          self.setState({distributor: dist})
          self.setState({song: record})
        })
    })
  }

  render () {
    if (!this.state.song) {
      return <div />
    }

    const compositionPane = compositionCredits.map((comp) => {
      return (
        <div>
          <br />
          <div><b>{comp.name}</b></div>
          <Table celled>
            <Table.Row>
              <Table.Cell width={3} singleLine>IPI Number: </Table.Cell>
              <Table.Cell>{comp.IPINumber}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell singleLine>Copyright Share: </Table.Cell>
              <Table.Cell>{comp.copyrightShare}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell singleLine>Published By: </Table.Cell>
              <Table.Cell>{comp.publishedBy}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell singleLine>PRO: </Table.Cell>
              <Table.Cell>{comp.PRO}</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell singleLine>Copyright Holder: </Table.Cell>
              <Table.Cell>{comp.copyrightHolder}</Table.Cell>
            </Table.Row>
          </Table>
          <br/>
        </div>
      )
    })

    const masterPane = (
      <Table celled>
        <Table.Row>
          <Table.Cell>Catalog Number: </Table.Cell>
          <Table.Cell>REP-0031314</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Performed by:</Table.Cell>
          <Table.Cell>Justin Bieber & BloodPop®</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Background Vocals by:</Table.Cell>
          <Table.Cell>Julia Michaels, BloodPop®</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Produced by:</Table.Cell>
          <Table.Cell>BloodPop®</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Vocal Production by:</Table.Cell>
          <Table.Cell>Josh Gudwin</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Mixed by:</Table.Cell>
          <Table.Cell>Mark “Spike” Stent</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Mixed assisted by:</Table.Cell>
          <Table.Cell>Michael Freeman</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Mixed At:</Table.Cell>
          <Table.Cell>The Mixsuite LA</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Mastered by:</Table.Cell>
          <Table.Cell>Chris Gehringer</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Mastered at:</Table.Cell>
          <Table.Cell>Sterling Sound</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Drum Programming by:</Table.Cell>
          <Table.Cell>BloodPop®</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Keys by:</Table.Cell>
          <Table.Cell>BloodPop®</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Synthesizer by:</Table.Cell>
          <Table.Cell>BloodPop®</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Bass by:</Table.Cell>
          <Table.Cell>BloodPop®</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Versions:</Table.Cell>
          <Table.Cell>Main, Instrumental, TV Track</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Samples used:</Table.Cell>
          <Table.Cell>N/A</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Recording Date:</Table.Cell>
          <Table.Cell>4/26/17</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Recording Engineer:</Table.Cell>
          <Table.Cell>Josh Gudwin</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Recording Studio:</Table.Cell>
          <Table.Cell>Henson Recording Studios</Table.Cell></Table.Row>
        <Table.Row>
          <Table.Cell>Recording Location:</Table.Cell>
          <Table.Cell>Hollywood, CA</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>A&R:</Table.Cell>
          <Table.Cell>Daouda Leonard, Wendy Goldstein</Table.Cell>
        </Table.Row>
      </Table>
    )

    const panes = [
      { menuItem: 'Master Recording', render: () => <Tab.Pane>{masterPane}</Tab.Pane> },
      { menuItem: 'Composition', render: () => <Tab.Pane>{compositionPane}</Tab.Pane> },
      { menuItem: 'Rights Control', render: () => <Tab.Pane>Coming Soon</Tab.Pane> },
    ]

    return (
      <div style={{paddingTop: 30}}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={12}>
              <h2 style={{margin: 0}}>{this.state.song.get('Song Title')}</h2>
              <h3 style={{margin: '5px 0 0 0', color: '#999'}}>{this.state.song.get('Artist Title')}</h3>

              <Item.Group>
                <Item>
                  <Item.Image size='medium' src={this.state.song.get('Artwork')[0].url} />
                  <Item.Content>
                    <Item.Meta>Genre: {this.state.song.get('Genre')}</Item.Meta>
                    <Item.Meta>Timecode: {this.state.song.get('Timecode')}</Item.Meta>
                    <Item.Meta>BPM: {this.state.song.get('BPM')}</Item.Meta>
                    <Item.Meta>Key: {this.state.song.get('Key')}</Item.Meta>
                    <Item.Meta>Distributor: {this.state.distributor.get('Company Name')}</Item.Meta>
                    <Item.Meta>ISRC: {this.state.song.get('ISRC Code')}</Item.Meta>
                    <Item.Meta>UPC: {this.state.song.get('UPC Code')}</Item.Meta>
                    <Item.Meta>Release Date: {this.state.song.get('Release Date')}</Item.Meta>
                  </Item.Content>
                </Item>
              </Item.Group>

            </Grid.Column>
            <Grid.Column width={4}>
              <Button primary fluid style={{marginBottom: 4}}>Edit</Button>
              <Button fluid style={{marginBottom: 5}}>Files</Button>
              <Button fluid style={{marginBottom: 3}}>Publish</Button>

              <div style={{fontSize: '20px', marginTop: 30}}>
                <Icon name='play circle' size='large' style={{marginRight: 10}} />
                {this.state.song.get('Streams')}
              </div>
              <div style={{fontSize: '20px', marginTop: 15}}>
                <Icon name='cloud download' size='large' style={{marginRight: 10}} />
                {this.state.song.get('Downloads')}
              </div>
              <div style={{fontSize: '20px', marginTop: 15}}>
                <Icon name='dollar' size='large' style={{marginRight: 10}} />
                {this.state.song.get('Total Revenue')}
              </div>
              <br />
              <center>
                <Link to={`/insights/${this.state.song.get('Dashboard')}`}>
                  <Button basic>More Activity</Button>
                </Link>
              </center>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              <Header dividing>Activity</Header>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              No Activity Yet
            </Grid.Column>
          </Grid.Row>


          <Grid.Row>
            <Grid.Column width={16}>
              <Tab panes={panes} />
            </Grid.Column>
          </Grid.Row>

        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/container/song/index.js